@if (isStickyVisible) {
  <app-section-template [isSticky]="true" [hasPadding]="false">
    <app-select-category
      [noPadding]="true">
    </app-select-category>
  </app-section-template>
}

<app-three-column-template
  [hasCustomMain]="true"
  [pageData]="pageData()"
  [showTags]="false">
  <app-side-navigation [pageData]="pageData()" slot="left-section"></app-side-navigation>
  <app-breadcrumbs [pageData]="pageData()" slot="breadcrumb-section"></app-breadcrumbs>


  <app-select-category
    [noLeftPadding]="true"
    slot="above-title">
  </app-select-category>

  @if (pageData().showContents) {
    <app-toc></app-toc>
  }
  <app-ck-viewer [fullBody]="true"
                 [htmlDescription]="pageData()?.htmlDescription"></app-ck-viewer>

  @if (pageData() && HELPER.FF.collections) {
    <app-collections [pageData]="pageData()"/>
  }


  @if (hasRelatedItems) {
    <app-horizontal-divider/>
    <div class="related-publications">
      <div class="title-h2">{{ 'Related publications'|translate }}</div>
      @for (item of pageData().items.items //noinspection ForBlockNonIterableVar; track item.id; let last = $last) {
        <app-publication-card [hasDesc]="true"
                              [cardType]="PublicationsType.RELATED"
                              [isLast]="last"
                              [publicationData]="item"></app-publication-card>
      }

      <app-see-all
        #seeAllBtn
        [disabled]="isSeeAllDisabled"
        (click)="seeAll($event)"
        [url]="HELPER.getUrl('related-publications')">
      </app-see-all>
    </div>
  }


  <ng-container slot="right-section">

    <app-links-section
      [isQuickLinks]="true"
      [links]="pageData()?.quickUrls"
      [title]="'Quick links'"></app-links-section>

    <app-default-portlets
      [hasPublication]="false"
      [pageData]="pageData()"></app-default-portlets>

  </ng-container>


</app-three-column-template>
